// import { CSSProperties, memo, useMemo } from 'react';
// import styles from './Timeline.module.scss';
// import mapNumber from '../../utils/mapNumber.ts';
// import parseTimelineValue from '../../utils/dateTime/parseTimelineValue.ts';

// const Component = ({ item, timelineStart, timelineEnd, onClick, timelineTransactions, short = false }: any) => {

//     const style = useMemo<CSSProperties>(() => {
//         const left = mapNumber(item.start, timelineStart, timelineEnd, 0, 100);
//         const right = mapNumber(parseTimelineValue(item.end), timelineStart, timelineEnd, 0, 100);

//         return {
//             left: `${left}%`,
//             width: `${right - left}%`,    
//             // backgroundColor: `#${(item.start & 0xFFFFFF).toString(16).padStart(6, '0')}`, // debug
//         };
//     }, [item, timelineStart, timelineEnd]);

//     const transactions = useMemo(() => {
//         if (!timelineTransactions?.length) {
//             return null;
//         }
//         const itemEnd = parseTimelineValue(item.end);

//         return timelineTransactions.filter((tr) => {
//             const startTime = new Date(tr.startedAt).getTime();
//             const endTime = new Date(tr.date).getTime();
//             return endTime >= item.start && startTime <= itemEnd;
//         }).map((tr) => {
//             const left = mapNumber(
//                 new Date(tr.startedAt).getTime(),
//                 item.start,
//                 itemEnd,
//                 0,
//                 100,
//             );
//             const right = mapNumber(
//                 new Date(tr.date).getTime(),
//                 item.start,
//                 itemEnd,
//                 0,
//                 100,
//             );
//             return (
//                 <div
//                     className={styles.transaction}
//                     style={{ left: `${left}%`, width: `${right - left}%` }}
//                     key={tr._id}
//                 />
//             );
//         });
//     }, [timelineTransactions, item]);

//     return (
//         <div className={styles.timelineItem} style={style}
//         >
//             {transactions}
//         </div>
//     );
// };

// export const TimelineItem = memo(Component);

import { CSSProperties, memo, useMemo } from 'react';
import styles from './Timeline.module.scss';
import mapNumber from '../../utils/mapNumber.ts';
import parseTimelineValue from '../../utils/dateTime/parseTimelineValue.ts';

const Component = ({ item, timelineStart, timelineEnd, onClick, timelineTransactions, short = false }: any) => {

  const style = useMemo<CSSProperties>(() => {
    const left = mapNumber(item.start, timelineStart, timelineEnd, 0, 100);
    const right = mapNumber(parseTimelineValue(item.end), timelineStart, timelineEnd, 0, 100);

    return {
      left: `${left}%`,
      width: `${right - left}%`,
    };
  }, [item, timelineStart, timelineEnd]);

  const transactions = useMemo(() => {
    if (!timelineTransactions?.length) {
      // console.log(`[TimelineItem] ❌ No transactions found for item`, {
      //   itemStart: new Date(item.start).toISOString?.(),
      //   itemEnd: item.end,
      //   timelineTransactionsLength: timelineTransactions?.length || 0,
      // });
      return null;
    }

    const itemEnd = parseTimelineValue(item.end);
    const filtered = timelineTransactions.filter((tr) => {
      const startTime = new Date(tr.startedAt).getTime();
      const endTime = new Date(tr.date).getTime();
      const include = endTime >= item.start && startTime <= itemEnd;
      return include;
    });

    // console.log(`[TimelineItem] 🔎 Checking transactions`, {
    //   itemStart: new Date(item.start).toISOString?.(),
    //   itemEnd: new Date(itemEnd).toISOString?.(),
    //   totalTransactions: timelineTransactions.length,
    //   matched: filtered.length,
    // });

    if (filtered.length === 0) {
      console.log(`[TimelineItem] ⚠️ No transactions matched for this item range.`);
      return null;
    }

    return filtered.map((tr) => {
      const startTime = new Date(tr.startedAt).getTime();
      const endTime = new Date(tr.date).getTime();
      const left = mapNumber(startTime, item.start, itemEnd, 0, 100);
      const right = mapNumber(endTime, item.start, itemEnd, 0, 100);
      // console.log(`[TimelineItem] ✅ Rendering transaction`, {
      //   trId: tr._id,
      //   startedAt: tr.startedAt,
      //   date: tr.date,
      //   left,
      //   width: right - left,
      // });

      return (
        <div
          className={styles.transaction}
          style={{ left: `${left}%`, width: `${right - left}%` }}
          key={tr._id}
        />
      );
    });
  }, [timelineTransactions, item]);

  return (
    <div className={styles.timelineItem} style={style}>
      {transactions}
    </div>
  );
};

export const TimelineItem = memo(Component);

